// eslint-disable-next-line import/prefer-default-export
export const TTU_CITY_CENTRE_PAGES_SRC = 'city-centre-pages';
